/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Internal_Server_ErrorInputs */

const th_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาดที่ระบบของเรา กรุณาลองใหม่อีกครั้ง`)
};

const en_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong at our end. Please try again.`)
};

const ja_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバー側で問題が発生しました。もう一度お試しください。`)
};

const zh_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们这边出了问题，请重试。`)
};

const es_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo ha fallado por nuestra parte. Inténtalo de nuevo.`)
};

const pt_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado do nosso lado. Tente de novo.`)
};

const id_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada yang salah di pihak kami. Silakan coba lagi.`)
};

const fr_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelque chose s’est mal passé de notre côté. Réessayez.`)
};

const tl_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May nagkamali sa panig namin. Pakisubukang muli.`)
};

const vi_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có gì đó sai ở phía chúng tôi. Vui lòng thử lại.`)
};

const ko_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저희 쪽에서 문제가 생겼습니다. 다시 시도해 주세요.`)
};

const de_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei uns ist etwas schiefgegangen. Bitte versuche es erneut.`)
};

const ru_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что-то пошло не так на нашей стороне. Попробуйте ещё раз.`)
};

const tr_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bizim tarafta bir şey ters gitti. Lütfen yeniden deneyin.`)
};

const it_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa è andato storto da parte nostra. Riprova.`)
};

const pl_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coś poszło nie tak po naszej stronie. Spróbuj ponownie.`)
};

const uk_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щось пішло не так з нашого боку. Спробуйте ще раз.`)
};

const hi_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारी ओर से कुछ गड़बड़ हो गई। कृपया फिर कोशिश करें।`)
};

const ar_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خلل لدينا. حاول مرة أخرى.`)
};

const ms_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada yang tidak kena di pihak kami. Sila cuba lagi.`)
};

const bn_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমাদের দিকে কিছু ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।`)
};

const zh_tw2_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們這邊出了問題，請再試一次。`)
};

const zh_hk2_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們這邊出了問題，請再試一次。`)
};

const ur_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ہماری طرف کچھ گڑبڑ ہوئی۔ براہ کرم دوبارہ کوشش کریں۔`)
};

const fa_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`از سمت ما مشکلی پیش آمد. لطفاً دوباره تلاش کنید.`)
};

const sw_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuna hitilafu upande wetu. Tafadhali jaribu tena.`)
};

const nl_err_internal_server_error = /** @type {(inputs: Err_Internal_Server_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er ging iets mis aan onze kant. Probeer het opnieuw.`)
};

/**
* | output |
* | --- |
* | "Something went wrong at our end. Please try again." |
*
* @param {Err_Internal_Server_ErrorInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_internal_server_error = /** @type {((inputs?: Err_Internal_Server_ErrorInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Internal_Server_ErrorInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_internal_server_error(inputs)
	if (locale === "ja") return ja_err_internal_server_error(inputs)
	if (locale === "zh") return zh_err_internal_server_error(inputs)
	if (locale === "es") return es_err_internal_server_error(inputs)
	if (locale === "pt") return pt_err_internal_server_error(inputs)
	if (locale === "id") return id_err_internal_server_error(inputs)
	if (locale === "fr") return fr_err_internal_server_error(inputs)
	if (locale === "tl") return tl_err_internal_server_error(inputs)
	if (locale === "vi") return vi_err_internal_server_error(inputs)
	if (locale === "ko") return ko_err_internal_server_error(inputs)
	if (locale === "de") return de_err_internal_server_error(inputs)
	if (locale === "ru") return ru_err_internal_server_error(inputs)
	if (locale === "tr") return tr_err_internal_server_error(inputs)
	if (locale === "it") return it_err_internal_server_error(inputs)
	if (locale === "pl") return pl_err_internal_server_error(inputs)
	if (locale === "uk") return uk_err_internal_server_error(inputs)
	if (locale === "hi") return hi_err_internal_server_error(inputs)
	if (locale === "ar") return ar_err_internal_server_error(inputs)
	if (locale === "ms") return ms_err_internal_server_error(inputs)
	if (locale === "bn") return bn_err_internal_server_error(inputs)
	if (locale === "zh-TW") return zh_tw2_err_internal_server_error(inputs)
	if (locale === "zh-HK") return zh_hk2_err_internal_server_error(inputs)
	if (locale === "ur") return ur_err_internal_server_error(inputs)
	if (locale === "fa") return fa_err_internal_server_error(inputs)
	if (locale === "sw") return sw_err_internal_server_error(inputs)
	if (locale === "nl") return nl_err_internal_server_error(inputs)
	return en_err_internal_server_error(inputs)
});